<template>
  <v-app id="inspire">
    <!--   <v-system-bar app>
      <v-icon>mdi-square</v-icon>

      <v-icon>mdi-circle</v-icon>

      <v-icon>mdi-triangle</v-icon>
    </v-system-bar> -->

    <v-app-bar app class="prim">
      <!--  hide-on-scroll -->
      <v-app-bar-nav-icon
        color="white"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>

      <v-avatar size="55px">
        <img alt="Avatar" src="./assets/salamat.jpg" />
      </v-avatar>

      <v-toolbar-title class="white--text farsi mr-2">
        سیستم ارسال مستندات بیمه سلامت استان فارس
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <div v-if="showing" class="wtxt">
        <!-- <span
          @click="changepass = true"
          class="text-decoration-underline"
          style="margin-left: 15px; cursor: pointer; color: whitesmoke"
          >تغییر رمز</span
        > -->
        {{ this.username }}
      </div>
      <v-btn
        v-if="showing"
        @click="eexit"
        class="ma-2 mb-3"
        text
        title="خروج"
        icon
      >
        <v-icon large color="orange" class="rotate-45">
          mdi-location-exit
        </v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer class="farsi" v-model="drawer" fixed temporary right>
      <!--  -->
      <v-alert
        color="blue-grey"
        dark
        dense
        @click="drawer = !drawer"
        icon=" mdi-microsoft-xbox-controller-menu "
        prominent
      >
        منوی اصلی
      </v-alert>
      <v-list-item class="farsi">
        <v-list-item-content class="farsi">
          <v-list-item-title class="title farsi">
            سیستم ارسال مستندات
          </v-list-item-title>
          <v-list-item-subtitle> سازمان بیمه سلامت </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item>
        <!-- <v-list-item-avatar>
          <v-img src="https://randomuser.me/api/portraits/men/78.jpg"></v-img>
        </v-list-item-avatar> -->

        <v-list-item-content>
          <v-list-item-title>طراحی از سامان سیستم </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-navigation-drawer>

    <v-main :class="showlogin ? 'hero grey lighten-2' : 'grey lighten-2'">
      <v-container mx-auto>
        <div v-if="showlogin">
          <Login @startdemo="demostart" @successlogin="mylogin"> </Login>
        </div>
        <div class="stik">
          <v-card elevation="4" class="stik" v-if="!showlogin">
            <v-tabs
              v-model="tab"
              align-with-title
              height="50px"
              class="farsi text--white"
              @change="onchnagetab"
              background-color="blue-grey darken-1"
            >
              <v-tabs-slider color="teal accent-2"></v-tabs-slider>

              <v-tab
                text--white
                :title="item.titl"
                ripple
                active-class="teal lighten-2"
                v-for="(item, index) in litems"
                :key="item.name"
                :href="'#' + item.name"
              >
                <span :class="setstyleblink(item.name)">
                  {{ item.name }}
                </span>
                <div class="tdv"></div>

                <v-icon
                  left
                  v-show="index > 0"
                  color="white"
                  size="22px"
                  @click="closetab(item)"
                >
                  mdi-account-check</v-icon
                >
              </v-tab>
            </v-tabs>

            <v-row>
              <v-col>
                <v-tabs-items v-model="tab">
                  <v-tab-item
                    width="800px"
                    v-for="item in litems"
                    :key="item.name"
                    :value="item.name"
                  >
                    <v-card
                      v-if="item.name !== 'درخواستهای قبلی'"
                      elevation="2"
                      outlined
                    >
                      <div class="stik">
                        <!--    <zoomer  :zname="'zz'+item"    :base64="bbase"></zoomer> -->
                        <v-row>
                          <v-col
                            style="display: none"
                            cols="12"
                            md="3 mr-5  mt-3   "
                          >
                            <v-btn class="teal white--text" @click="getcapture">
                              گرفتن عکس
                              <v-icon
                                color="white"
                                size="28"
                                class="mr-6"
                                right
                              >
                                mdi-camera-enhance</v-icon
                              ></v-btn
                            >
                            <input
                              style="display: none"
                              type="file"
                              accept="image/*"
                              capture="camera"
                              id="cameraInput"
                              @change="handleFileSelect"
                            />
                          </v-col>
                          <v-col
                            style="display: none"
                            cols="12"
                            md="3 mr-5  mt-3   "
                          >
                            <div
                              :key="'divv' + index"
                              v-for="(item, index) in imageslist"
                            >
                              <v-icon
                                color="red"
                                size="25"
                                @click="deleteditemimage(index)"
                              >
                                mdi-close-circle-outline
                              </v-icon>
                              <v-img
                                :key="'imggg' + index"
                                class="imgg"
                                style=""
                                :src="item.src"
                              >
                              </v-img>
                              <v-chip
                                v-if="item.tp == 1"
                                class="white--text"
                                :color="'#3293ca'"
                              >
                                فرم پزشک معالج
                              </v-chip>
                              <v-chip
                                v-if="item.tp == 2"
                                class="white--text"
                                :color="'#3293ca'"
                              >
                                آزمایشها
                              </v-chip>
                              <v-chip
                                v-if="item.tp == 3"
                                class="white--text"
                                :color="'#3293ca'"
                              >
                                تصویربرداری
                              </v-chip>
                              <v-chip
                                v-if="item.tp == 4"
                                class="white--text"
                                :color="'#3293ca'"
                              >
                                سایر مدارک
                              </v-chip>
                            </div>
                          </v-col>
                          <v-col cols="10" md="3 mr-5  mt-3   ">
                            <v-text-field
                              v-model="melli"
                              v-on:keyup.13="gotopass"
                              label=" کد ملی"
                              ref="mellic"
                              idd="melcode"
                              required
                              maxlength="10"
                              type="tel"
                              append-icon="mdi-account"
                            ></v-text-field>
                            <v-text-field
                              v-model="rahh"
                              type="tel"
                              v-on:keyup.13="gotopass"
                              label="کد رهگیری نسخه"
                              ref="rahgir"
                              maxlength="6"
                              required
                              append-icon="mdi-barcode"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            style="color: #ef5350"
                            cols="10"
                            sm="3"
                            md="3 mr-3  mt-1   "
                          >
                            ارسال فرم پزشک معالج و تکمیل تمام قسمتهای آن همراه
                            با مهر پزشک ضروری است
                          </v-col>
                          <v-col style="" cols="10" sm="3" md="3 mr-5  mt-3   ">
                            <v-alert
                              height="30px"
                              color="blue-grey"
                              dark
                              dense
                              prominent
                            >
                              تصویر مدارک - حداکثر پنج مدرک
                            </v-alert>
                            <VueFileAgent
                              helpText="کلیک کنید"
                              ref="imgFileAgent"
                              class="bg-dark"
                              :thumbnailSize="100"
                              style="background: #5f5e5e"
                              v-model="fileRecords"
                              :deletable="true"
                              :editable="true"
                              :linkable="true"
                              :theme="theme"
                              @beforedelete="onBeforeDelete($event, 1)"
                              :uploadUrl="uploadUrl"
                              @select="filesSelected($event)"
                              @delete="fileDeleted($event)"
                              :sortable="sortable"
                              @change="handleFileChange($event)"
                              :resumable="resumable"
                              :maxSize="valMaxSize"
                              :accept="'image/*'"
                            ></VueFileAgent>
                          </v-col>
                          <v-col
                            style=""
                            cols="10"
                            sm="3"
                            md="3 mr-5  mt-3   "
                            v-if="editmode"
                          >
                            <v-alert
                              height="30px"
                              color="blue-grey"
                              dark
                              dense
                              prominent
                            >
                              اسناد بارگذاری شده
                            </v-alert>
                            <VueFileAgent
                              ref="imgFileAgentlist"
                              v-model="listoffiles"
                              class="bg-dark"
                              style="background: #5f5e5e"
                              :deletable="true"
                              :editable="false"
                              :linkable="true"
                              :readonly="true"
                              :theme="themelist"
                              @beforedelete="onBeforeDelete($event, 1)"
                              @select="filesSelected($event)"
                              @delete="fileDeleted($event)"
                              :maxSize="valMaxSize"
                            ></VueFileAgent>
                          </v-col>
                          <v-col
                            v-if="false"
                            cols="10"
                            style=""
                            sm="6"
                            md="3 mr-5  mt-3   "
                          >
                            <v-alert
                              height="30px"
                              color="blue-grey"
                              dark
                              dense
                              prominent
                            >
                              آزمایشها یا پاتولوژی
                            </v-alert>
                            <VueFileAgent
                              ref="imgFileAgentaz"
                              class="bg-dark"
                              style="background: #5f5e5e"
                              v-model="fileRecordsaz"
                              :deletable="true"
                              :editable="true"
                              :linkable="true"
                              :theme="theme"
                              @beforedelete="onBeforeDelete2($event, 2)"
                              :uploadUrl="uploadUrl"
                              @select="filesSelected($event)"
                              @delete="fileDeleted($event)"
                              :sortable="sortable"
                              @change="handleFileChange($event)"
                              :resumable="resumable"
                              :maxSize="valMaxSize"
                              :accept="'image/*,.pdf'"
                            ></VueFileAgent>
                          </v-col>
                          <v-col
                            v-if="false"
                            cols="10"
                            style=""
                            sm="6"
                            md="3 mr-5  mt-3   "
                          >
                            <v-alert
                              height="30px"
                              color="blue-grey"
                              dark
                              dense
                              prominent
                            >
                              سونوگرافی یا تصویربرداری
                            </v-alert>
                            <VueFileAgent
                              ref="imgFileAgenttas"
                              class="bg-dark"
                              style="background: #5f5e5e"
                              v-model="fileRecordtas"
                              :deletable="true"
                              :editable="true"
                              :linkable="true"
                              :theme="theme"
                              @beforedelete="onBeforeDelete3($event, 3)"
                              :uploadUrl="uploadUrl"
                              @select="filesSelected($event)"
                              @delete="fileDeleted($event)"
                              :sortable="sortable"
                              @change="handleFileChange($event)"
                              :resumable="resumable"
                              :maxSize="valMaxSize"
                              :accept="'image/*,.pdf'"
                            ></VueFileAgent>
                          </v-col>
                          <v-col
                            v-if="false"
                            cols="10"
                            style=""
                            sm="6"
                            md="3 mr-5  mt-3   "
                          >
                            <v-alert
                              height="30px"
                              color="blue-grey"
                              dark
                              dense
                              prominent
                            >
                              سایر مدارک
                            </v-alert>
                            <VueFileAgent
                              ref="imgFileAgentama"
                              class="bg-dark"
                              style="background: #5f5e5e"
                              v-model="fileRecordtamal"
                              :deletable="true"
                              :editable="true"
                              :linkable="true"
                              :theme="theme"
                              @beforedelete="onBeforeDelete4($event, 4)"
                              :uploadUrl="uploadUrl"
                              @select="filesSelected($event)"
                              @delete="fileDeleted($event)"
                              :sortable="sortable"
                              @change="handleFileChange($event)"
                              :resumable="resumable"
                              :maxSize="valMaxSize"
                              :accept="'image/*,.pdf'"
                            ></VueFileAgent>
                          </v-col>
                          <v-col cols="10" md="6 mr-5  mt-1   ">
                            <v-alert
                              height="30px"
                              color="blue-grey"
                              dark
                              dense
                              prominent
                            >
                              توضیحات
                            </v-alert>
                            <v-textarea
                              bg-color="grey lighten-2"
                              color="cyan"
                              rows="4"
                              v-model="payam"
                              auto-grow
                            ></v-textarea>
                          </v-col>

                          <v-col cols="6" md="4 mr-8  mt-1   ">
                            <v-btn
                              :disabled="disbtnsave"
                              :loading="disbtnsave"
                              id="step1"
                              class="savbtn mx-auto white--text teal darken-1 mt-4 farsi"
                              width="300px"
                              @click.prevent="getiddsave"
                            >
                              ذخیره و ارسال
                              <v-icon size="28" class="mr-6" right
                                >check_circle</v-icon
                              >
                            </v-btn>
                            <v-btn
                              id="step2"
                              class="savbtn mx-auto white--text blue-grey darken-1 mt-5 farsi"
                              width="300px"
                              @click.prevent="clearpage"
                            >
                              انصراف
                            </v-btn>
                          </v-col>
                        </v-row>
                      </div>
                    </v-card>
                    <v-card
                      height="600px"
                      v-if="item.name == 'درخواستهای قبلی'"
                    >
                      <v-row class="teal lighten-5">
                        <v-col cols="3" class="mt-2 mr-2 mb-2">
                          <date-picker
                            v-model="date"
                            color="#00796B"
                            auto-submit
                            @change="settarikh"
                            label="از تاریخ"
                          />
                        </v-col>

                        <v-checkbox
                          style="margin-right: 85px"
                          v-model="allsanad"
                          @click="refreshallsanad"
                          color="indigo-darken-3"
                          value="indigo-darken-3"
                          label=" تمام درخواستها "
                        ></v-checkbox>
                      </v-row>
                      <v-data-table
                        id="meme"
                        fixed-header
                        height="500px"
                        v-model="selected"
                        :headers="columns"
                        :single-select="singleSelect"
                        :items="rows"
                        @click:row="handleClick"
                        disable-pagination
                        item-key="idd"
                        sort-by="idd"
                        :sort-desc="true"
                        loading-text="Loading... Please wait"
                        class="elevation-1 farsi mytable"
                        :footer-props="{
                          showFirstLastPage: false,
                          firstIcon: '',
                          lastIcon: '',
                          prevIcon: '',
                          nextIcon: '',
                        }"
                      >
                        <template v-slot:[`item.idd`]="{ item }">
                          <span
                            @click="editrows(item.idd, item.coml, item.rah)"
                            class="iddpointer mellicss font-weight-bold text-decoration-underline"
                          >
                            {{ item.idd }}
                          </span>
                        </template>
                        <template v-slot:[`item.coml`]="{ item }">
                          <span class="mellicss font-weight-bold">
                            {{ item.coml }}
                          </span>
                        </template>
                        <template v-slot:[`item.pm`]="{ item }">
                          <div style="display: flex">
                            <v-btn
                              :color="
                                item.ins == 1
                                  ? 'orange lighten-2'
                                  : 'grey lighten-3'
                              "
                              x-small
                              fab
                            >
                              <v-icon
                                :color="
                                  item.ins == 1 ? 'white' : 'orange lighten-2'
                                "
                                class="material-icons-round"
                                @click="showpayam(item.idd)"
                                >mdi-message-text-outline</v-icon
                              >
                            </v-btn>
                            <v-icon
                              v-if="item.tedat > 0"
                              class="material-icons-round"
                              >mdi-attachment mdi-rotate-90</v-icon
                            >
                          </div>
                        </template>

                        <template v-slot:[`item.ta`]="{ item }">
                          {{ showtarikh(item.ta) }}
                        </template>
                        <template v-slot:[`item.vas`]="{ item }">
                          <v-chip
                            class="white--text"
                            v-if="item.vas == '1'"
                            :color="'#3293ca'"
                          >
                            ثبت اولیه
                          </v-chip>
                          <v-chip
                            class="white--text"
                            v-if="item.vas == '2'"
                            :color="'#9fd302'"
                          >
                            درحال بررسی
                          </v-chip>
                          <v-chip
                            class="white--text"
                            v-if="item.vas == '3'"
                            :color="'#239c8c'"
                          >
                            تائید شده
                          </v-chip>
                          <v-chip
                            class="white--text"
                            v-if="item.vas == '6'"
                            :color="'#60286b'"
                          >
                            بایگانی شد
                          </v-chip>
                          <v-chip
                            class="white--text text-decoration-underline"
                            v-if="item.vas == '4'"
                            :color="'#FFA726'"
                            @click="showpayam(item.idd)"
                          >
                            مشاهده نقص مدارک
                          </v-chip>
                          <v-chip
                            class="white--text"
                            v-if="item.vas == '5'"
                            :color="'#e46c4e'"
                          >
                            رد شده
                          </v-chip>

                          <!--    <div v-else>{{ item.vas }}</div> -->
                        </template>
                        <template v-slot:[`item.menu1`]="{ item }">
                          <v-menu>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                :key="'bt' + item.idd"
                                v-bind="attrs"
                                v-on="on"
                                icon
                                @click="selectCurrentRow(item)"
                              >
                                <v-icon color=" blue-grey darken-2"
                                  >mdi-dots-vertical-circle</v-icon
                                >
                              </v-btn>
                            </template>

                            <v-list>
                              <v-list-item class="row-pointer lstitem">
                                <v-list-item-title
                                  @click="
                                    editrows(item.idd, item.coml, item.rah)
                                  "
                                  >رفع نقص</v-list-item-title
                                >
                              </v-list-item>
                              <v-list-item class="row-pointer lstitem">
                                <v-list-item-title
                                  @click="setbayegani(item.idd, item.vas)"
                                  >بایگانی شود</v-list-item-title
                                >
                              </v-list-item>
                              <v-list-item class="row-pointer lstitem">
                                <v-list-item-title
                                  @click="quesshow(item.idd, item.vas)"
                                  >حذف درخواست
                                </v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </template>
                        <template slot="body.append"> </template>

                        <template v-slot:footer.page-text>
                          <div class="panev white--text">
                            تعداد درخواست : {{ totalcon }}
                            <div class="dwnlink">
                              <v-icon
                                color="#7ff1ec"
                                @click="downfilepezeshk('فرم گزارش پزشک.pdf')"
                                >mdi-arrow-down-bold-circle-outline</v-icon
                              >
                              <a @click="downfilepezeshk('فرم گزارش پزشک.pdf')"
                                >فرم گزارش پزشک معالج</a
                              >
                            </div>
                          </div>
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
          </v-card>
        </div>

        <v-dialog
          v-model="quesdelete"
          transition="dialog-bottom-transition"
          width="auto"
        >
          <v-card class="farsi">
            <v-toolbar class="white--text" color="#0097A7" title="ثبت درخواست"
              >حذف درخواست</v-toolbar
            >
            <v-card-text>
              <div class="text-h5 pa-12">
                آیا برای حذف درخواست مطمئن هستید ؟
              </div>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn
                class="white--text blue-grey"
                variant="text"
                @click="deleterequest(1)"
                >تائید</v-btn
              >
              <v-btn @click="quesdelete = false" variant="text">انصراف</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="changepass"
          class="farsi"
          persistent
          transition="dialog-top-transition"
          max-width="500"
        >
          <template v-slot:default="changepass">
            <v-card>
              <v-alert
                class="farsi"
                color="blue-grey"
                dark
                dense
                icon="mdi-onepassword  "
                prominent
              >
                تغییر رمز
              </v-alert>
              <v-text-field
                type="password"
                label="رمز جدید:"
                class="mx-15 mt-6"
                hide-details="auto"
                v-model="ps1"
                counter="20"
              ></v-text-field>
              <v-text-field
                type="password"
                label="تکرار رمز جدید:"
                class="mx-15 mt-6"
                hide-details="auto"
                v-model="ps2"
                counter="20"
              ></v-text-field>
              <br />
              <br />

              <v-card-actions class="justify-end">
                <v-btn @click="savepass" class="blue-grey darken-3 farsi" dark
                  >ذخیره</v-btn
                >
                <v-btn class="farsi" outlined @click="changepass.value = false"
                  >بستن</v-btn
                >
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>

        <v-dialog
          v-model="dialogsave"
          transition="dialog-bottom-transition"
          width="auto"
        >
          <v-card class="farsi">
            <v-toolbar class="white--text" color="#0097A7" title="ثبت درخواست"
              >ثبت درخواست</v-toolbar
            >
            <v-card-text>
              <div class="text-h4 pa-12">
                درخواست شما با کد درخواست {{ newid }} ثبت شد
              </div>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn outlined variant="text" @click="closedialog">بستن</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="dialogpayam"
          transition="dialog-bottom-transition"
          scrollable
          width="auto"
        >
          <v-card class="farsi">
            <v-toolbar class="white--text" color="#0097A7" title="ثبت درخواست"
              >پیام ها
            </v-toolbar>
            <v-card-text>
              <v-textarea
                ref="vtxt"
                :rules="[checkmatn]"
                auto-grow
                rows="10"
                class="dlgarea"
                bg-color="grey lighten-2"
                v-model="payam"
              >
              </v-textarea>
            </v-card-text>
            <v-card-actions
              style="flex-direction: column; align-items: start"
              class="justify-end"
            >
              <div v-for="item in attachfile" :key="item.name">
                <v-icon color="blue">mdi-download</v-icon>
                <span @click="downfile(item.name)" class="listfile">
                  {{ item.name }}</span
                >
              </div>
            </v-card-actions>
            <v-card-actions class="justify-end">
              <v-btn
                color="teal darken-1n"
                class="white--text"
                variant="text"
                @click="savepayam"
                >ذخیره</v-btn
              >
              <v-btn outlined variant="text" @click="closedialogpayam"
                >بستن</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="typeselect" scrollable width="auto">
          <v-card>
            <v-card-title>نوع سند را انتخاب کنید</v-card-title>
            <v-divider></v-divider>
            <v-card-text style="height: 300px">
              <v-radio-group v-model="selecteditem" column>
                <v-radio label="فرم پزشک معالج" value="1"></v-radio>
                <v-radio label="آزمایش" value="2"></v-radio>
                <v-radio label="تصویربرداری" value="3"></v-radio>

                <v-radio label="سایر مدارک" value="4"></v-radio>
              </v-radio-group>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn
                class="white--text blue-grey"
                color="blue-darken-1"
                variant="text"
                @click="saveselectitem"
              >
                تائید
              </v-btn>
              <v-btn
                color="blue-darken-1"
                variant="text"
                @click="typeselect = false"
              >
                لغو
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import io from "socket.io-client";
import Login from "./components/Login.vue";
import sound from "./assets/income.mp3";
//import { bus } from './main';

export default {
  components: {
    Login,
  },

  data: () => ({
    totalcon: 0,
    socket: null,
    origigpayam: "",
    ps1: "",
    ps2: "",
    changepass: false,
    lastimageurl: "",
    typeselect: false,
    selecteditem: -1,
    imageslist: [],
    allsanad: false,
    disbtnsave: false,
    date: "1402/08/15",
    date2: "14020810",
    editmode: false,
    cuurentidd: 0,
    quesdelete: false,
    deleteidd: 0,
    payam: "",
    singleSelect: true,
    dialogsave: false,
    dialogpayam: false,
    descr: "",
    descrins: "",
    theme: "default",
    themelist: "list",
    fileRecordtamal: [],
    fileRecordtas: [],
    fileRecordsaz: [],
    fileRecords: [],
    listoffiles: [],
    sortable: false,
    resumable: true,
    uploadUrl: "",
    valMaxSize: "4MB",
    files: [],
    baseaddress: "https://pz.ihiof.ir/apicap", //"https://pz.ihiof.ir/apicap",
    newid: 0,
    progres: false,
    subject: [],
    institle: "",
    username: "",

    showlogin: true,
    counter: 0,
    ischap: false,
    headers: [],
    items: [],
    rows: [],
    unfilterrows: [],
    singleSelect: "",
    selected: [],
    columns: [],

    model: 25,
    fastview: false,

    iscode: 0,
    phoneNumberRule: [(v) => /^\d+$/.test(v) || "فقط اعداد"],

    result: [], // [{sb:"ماموریت" ,des:"اجرا برای پیگیری های بعدی"  , id:120} ,{sb:"ماموریت" ,des:"نامه ارسالی به کمیسیون"  , id:121},{sb:"انتقالی" ,des:"ماموریت اقای حسنی به سازمان "  , id:122},{sb:"ماموریت" ,des:"نامه ارسالی به کمیسیون"  , id:123},{sb:"انتقالی" ,des:"ماموریت اقای حسنی به سازمان "  , id:124},{sb:"ماموریت" ,des:"نامه ارسالی به کمیسیون"  , id:125},{sb:"انتقالی" ,des:"ماموریت اقای حسنی به سازمان "  , id:126},{sb:"ماموریت" ,des:"نامه ارسالی به کمیسیون"  , id:127},{sb:"انتقالی" ,des:"ماموریت اقای حسنی به سازمان "  , id:128},{sb:"ماموریت" ,des:"نامه ارسالی به کمیسیون"  , id:129},{sb:"انتقالی" ,des:"ماموریت اقای حسنی به سازمان "  , id:130}]
    disi: false,

    subj: "",

    code: "",

    desc: "",

    bbase: `data:image/gif;base64,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`,
    matn: "matn",
    idd: 100,

    tab: "",

    litems: [
      { idd: 100, name: "ثبت درخواست تائید", code: 10 },
      { idd: 101, name: "درخواستهای قبلی", code: 9 },
    ],

    drawer: null,
    user: "",
    pass: "",
    valid: true,
    name: "",
    acc: "",
    ostan: "",
    melli: "",
    rahh: "",
    tt: {},
    prevmelli: "",
    prevmelli2: "",
    attachfile: [],

    lastsanad: [],

    showing: false,
    demo: false,
  }),
  mounted() {
    var ss = window.location.protocol;
    if (ss == "https:") {
      this.baseaddress = "https://pz.ihiof.ir/apicap";
    }
    // this.baseaddress = "http://172.168.115.5:8080";

    // document.getElementsByClassName("help-text")[0].innerHTML = "کلیک کنید ";

    /*  setTimeout(() => {
      this.getlist();
    }, 2000); */
  },

  created() {
    document.title = "سیستم ارسال مستندات بیمه سلامت  ";
    let that = this;
    document.addEventListener("keyup", (evt) => {
      if (evt.keyCode === 27 && !this.savepayam) {
        that.clearpage();
      }
    });

    this.columns = [
      {
        text: "کد درخواست",
        align: "start",
        width: "80px",

        value: "idd",
        class: "blue-grey  white--text",
      },
      {
        text: "تاریخ",
        align: "start",
        width: "100px",

        value: "ta",
        class: "blue-grey  white--text",
      },
      {
        text: "کد ملی",
        align: "start",
        width: "90px",
        value: "coml",
        class: "blue-grey  white--text",
      },
      {
        text: "کد رهگیری",
        width: "100px",
        value: "rah",
        class: "blue-grey  white--text",
      },
      {
        text: "ساعت ثبت",
        width: "80px",
        value: "sat",
        class: "blue-grey  white--text",
      },
      {
        text: "وضعیت",
        width: "100px",
        value: "vas",
        class: "blue-grey  white--text",
      },
      {
        text: "کارشناس",
        width: "80px",
        value: "kar",
        class: "blue-grey  white--text",
      },
      {
        text: "پیام",
        width: "60px",
        value: "pm",
        class: "blue-grey  white--text",
      },
      {
        text: "-",
        width: "90px",
        value: "menu1",
        class: "blue-grey  white--text",
      },
    ];
  },

  methods: {
    setstyleblink(name) {
      if (name == "ثبت درخواست تائید") return "wtxt  ";
      else return "wtxt  ";
    },

    downfile(file) {
      let axiosConfig = {
        headers: {
          pass: "229101",
          Authorization: "Bearer " + localStorage.getItem("auth"),
        },
        responseType: "blob",
        params: {
          idd2: this.cuurentidd,
          name: file,
        },
      };

      axios
        .get(
          this.baseaddress + "/downattach",

          axiosConfig
        )
        .then((response) => {
          //  console.log(response.data);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file);
          document.body.appendChild(link);
          link.click();

          // console.log(response.data);
          // this.progres = true;
          //document.getElementById("lstitem40").scrollIntoView();
          //response.data
        })
        .catch((err) => {
          console.log("no data" + err);

          //if (err.response.status == 401) this.iscode = 2;
        });
    },
    downfilepezeshk(file) {
      let axiosConfig = {
        headers: {
          pass: "229101",
          Authorization: "Bearer " + localStorage.getItem("auth"),
        },
        responseType: "blob",
        params: {
          idd2: this.cuurentidd,
          name: file,
        },
      };

      axios
        .get(
          this.baseaddress + "/downattachpez",

          axiosConfig
        )
        .then((response) => {
          //  console.log(response.data);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          console.log("url", url);
          link.href = url;
          link.setAttribute("download", file);
          document.body.appendChild(link);
          link.click();

          // console.log(response.data);
          // this.progres = true;
          //document.getElementById("lstitem40").scrollIntoView();
          //response.data
        })
        .catch((err) => {
          console.log("no data" + err);

          //if (err.response.status == 401) this.iscode = 2;
        });
    },
    playSound() {
      if (sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },
    checkmatn(m) {
      return (
        m.includes(this.origigpayam) || "اجازه پاک کردن متنهای قبلی را ندارید"
      );
    },

    savepass() {
      if (this.ps1 != this.ps2) {
        this.showtoast("رمز عبور ها یکسان نیستند ");
        return;
      }
      if (this.ps1 === "") {
        this.showtoast("رمز عبور خالی است  ");
        return;
      }

      let axiosConfig = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      axios
        .post(
          this.baseaddress + "/changepassdrug",
          {
            idd2: this.user,
            user: this.user,
            pass: this.ps1,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("auth"),
            },
          }
        )
        .then((response) => {
          // localStorage.setItem("auth", response.data.access_token);
          // console.log(response.datas);
          this.ps1 = "";
          this.ps2 = "";
          this.changepass = false;
          // console.log(this.pass);

          //  this.$emit("logof", false);
          this.showtoast("رمز جدید با موفقیت تغییر یافت  ");
        })
        .catch((err) => {
          /*
          if(err.toJSON().message === 'Network Error'){
        alert('no internet connection');

        } */

          if (!err.response) {
            this.showtoast("ارتباط خود با اینترنت را چک کنید");
            console.log("قطع است ");
          }
        });
    },
    settarikh() {
      console.log("ddd");
      let t = this.date;
      this.date2 = t.replaceAll("/", "");
      this.getlist();
    },
    async compressImage(file, { quality = 1, type = file.type }) {
      // Get as image data
      const imageBitmap = await createImageBitmap(file);
      let maxWidth = 800;
      let maxHeight = 1280;

      let newWidth = imageBitmap.width;
      let newHeight = imageBitmap.height;

      if (maxWidth && newWidth > maxWidth) {
        newWidth = maxWidth;
        newHeight = (maxWidth / imageBitmap.width) * imageBitmap.height;
      }

      if (maxHeight && newHeight > maxHeight) {
        newHeight = maxHeight;
        newWidth = (maxHeight / imageBitmap.height) * imageBitmap.width;
      }
      // Draw to canvas
      const canvas = document.createElement("canvas");
      canvas.width = newWidth;
      canvas.height = newHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(imageBitmap, 0, 0, newWidth, newHeight);

      // Turn into Blob
      const blob = await new Promise((resolve) =>
        canvas.toBlob(resolve, type, quality)
      );

      // Turn Blob into File
      return new File([blob], file.name, {
        type: blob.type,
      });
    },
    getcapture() {
      document.getElementById("cameraInput").click();
    },

    deleteditemimage(index) {
      this.imageslist.splice(index, 1);
    },

    saveselectitem() {
      this.typeselect = false;
      this.imageslist.push({
        src: this.lastimageurl,
        tp: this.selecteditem,
      });

      console.log("image", this.imageslist);
    },

    async handleFileSelect(event) {
      const file = event.target.files[0];

      if (file) {
        console.log(file);

        const compressedFile = await this.compressImage(file, {
          // 0: is maximum compression
          // 1: is no compression
          quality: 0.7,

          // We want a JPEG file
          type: "image/jpeg",
        });
        console.log(compressedFile);
        return;
        const reader = new FileReader();

        reader.onload = (e) => {
          const imageUrl = e.target.result;
          // selectedImage.src = imageUrl;

          this.lastimageurl = imageUrl;
          this.typeselect = true;
          // Convert the image content to base64

          // const base64Image = imageUrl.split(",")[1];
          // console.log("Base64 image:", base64Image);
        };

        reader.readAsDataURL(file);
      }
    },

    refreshallsanad() {
      this.getlist();
    },
    async editrows(idd, coml, rah) {
      this.cuurentidd = idd;
      let r = await this.getvasiat(idd);

      console.log("vas", r);
      if (r == 2) {
        this.showtoast("سند در حال بررسی است اجازه ویرایش ندارید");

        return;
      }
      this.tab = "ثبت درخواست تائید";
      this.editmode = true;
      this.pishmelli = coml;
      this.rahh = rah;
      this.newid = idd;
      this.payam = this.rows.find((x) => x.idd === idd).pm;

      this.searchsanad();
    },

    async quesshow(idd, vas) {
      let t = await this.getvasiat(idd);

      if (t > 1) {
        this.showtoast("اجازه حذف ندارید");

        return;
      }

      this.deleteidd = idd;
      this.quesdelete = true;
    },

    selectCurrentRow(item) {
      this.selected = [item];
    },

    selectRow(item) {
      // this.selected = item;
    },

    showpayam(idd) {
      this.payamseen(idd);
      this.cuurentidd = idd;
      this.descrins = "";
      this.payam = this.rows.find((x) => x.idd === idd).pm;
      this.origigpayam = this.payam;
      this.dialogpayam = true;

      this.attachfile = [];

      let axiosConfig = {
        headers: {
          pass: "229101",
          Authorization: "Bearer " + localStorage.getItem("auth"),
        },
      };

      axios
        .post(
          this.baseaddress + "/getallattach",
          {
            idd2: this.cuurentidd,
          },
          axiosConfig
        )
        .then((response) => {
          console.log(response.data);
          this.attachfile = response.data;
          // this.progres = true;

          //document.getElementById("lstitem40").scrollIntoView();

          //response.data
        })
        .catch((err) => {
          console.log("no data" + err);

          //  this.showtoast("سندی با مشخصات فوق پیدا نشد ");

          //if (err.response.status == 401) this.iscode = 2;
        });
    },

    gotopass() {
      this.$refs.rahgir[0].focus();
    },
    showtarikh(ta) {
      let a = ta + "";
      return a.slice(0, 4) + "/" + a.slice(4, 6) + "/" + a.slice(6, 9);
    },
    delrows(i) {
      console.log(i);
    },

    handleClick(item, row) {
      // let selectState = row.isSelected ? false : true;
      row.select(true);
    },
    closedialog() {
      this.dialogsave = false;
      this.getlist();
      setTimeout(() => {
        this.tab = "درخواستهای قبلی";
        this.showtoast6(
          "جواب در خواست شما در همین صفحه و همچنین با ارسال پیامک پاسخ داده خواهد شد"
        );
      }, 1000);

      /* setTimeout(() => {
        this.code = "";
        this.$refs.mellic[0].focus();
      }, 1000); */
    },
    closedialogpayam() {
      this.dialogpayam = false;
    },
    clearpage() {
      this.fileRecordtamal = [];
      this.fileRecordtas = [];
      this.fileRecordsaz = [];
      this.fileRecords = [];
      this.rahh = "";
      // this.melli = "";
      this.descr = "";
      this.descrins = "";
      this.payam = "";

      this.disbtnsave = false;
      this.editmode = false;
      // this.dialogsave = true;
      this.$refs.mellic[0].focus();
    },

    async getiddsave() {
      if (this.melli.length < 10) {
        this.showtoast(" کد ملی معتبر نیست");
        return;
      }
      if (this.melli.includes("?")) {
        this.showtoast(" کد ملی نامعتبر است صفحه کلید را لاتین نمائید");
        return;
      }
      if (this.rahh.includes("?")) {
        this.showtoast(" کد رهگیری نامعتبر است صفحه کلید را لاتین نمائید");
        return;
      }

      if (this.prevmelli.length > 2 && this.prevmelli2.length > 2)
        if (this.melli != this.prevmelli && this.melli != this.prevmelli2) {
          this.showtoast(
            "شما فقط مجاز به ثبت نسخ با کد ملی " +
              this.prevmelli +
              "," +
              this.prevmelli2 +
              " هستید"
          );
          return;
        }

      console.log("rah", this.rahh);
      if (this.rahh == "") {
        this.showtoast(" کد رهگیری خالی است ");
        return;
      }

      if (
        this.fileRecords.length == 0 &&
        this.fileRecordsaz.length == 0 &&
        this.fileRecordtas.length == 0 &&
        this.fileRecordtamal.length == 0
      ) {
        this.showtoast(" هیچ مدرکی ضمیمه نشده است ");
        return;
      }

      if (this.editmode) {
        this.newid = this.cuurentidd;

        console.log(this.newid);
        this.sendreques();

        return;
      }

      let axiosConfig = {
        headers: {
          pass: "229101",
          Authorization: "Bearer " + localStorage.getItem("auth"),
        },
      };

      axios
        .post(
          this.baseaddress + "/getidsam",
          {
            user: this.user,
          },
          axiosConfig
        )
        .then((response) => {
          console.log("idd  ", response.data.idd);
          this.disbtnsave = true;
          this.newid = response.data.idd;
          this.sendreques();
        })
        .catch((err) => {
          console.log(err.response);
          return 0;
        });
    },

    async sendreques() {
      //this.newid = await this.getidd();
      console.log("idd", this.newid);
      // this.user = "1";
      let formData = new FormData();
      formData.append("user", this.user);
      formData.append("code", this.newid);
      formData.append("melli", this.melli);
      formData.append("rah", this.rahh);
      formData.append("desc", this.payam);
      formData.append("pez", this.fileRecords.length);
      formData.append("az", this.fileRecordsaz.length);
      formData.append("rad", this.fileRecordtas.length);
      formData.append("amal", this.fileRecordtamal.length);

      if (this.fileRecords.length > 0) {
        for (let index = 0; index < this.fileRecords.length; index++) {
          const file = this.fileRecords[index];
          if (file.type.startsWith("image")) {
            let compressedFile = await this.compressImage(file.file, {
              quality: 0.7,
              type: "image/jpeg",
            });

            formData.append("files", compressedFile);
          } else {
            formData.append("files", file.file);
          }
        }
      }
      if (this.fileRecordsaz.length > 0) {
        for (let index = 0; index < this.fileRecordsaz.length; index++) {
          const file = this.fileRecordsaz[index];
          if (file.type.startsWith("image")) {
            let compressedFile = await this.compressImage(file.file, {
              quality: 0.7,
              type: "image/jpeg",
            });

            formData.append("files", compressedFile);
          } else {
            formData.append("files", file.file);
          }
        }
      }

      if (this.fileRecordtas.length > 0) {
        for (let index = 0; index < this.fileRecordtas.length; index++) {
          const file = this.fileRecordtas[index];
          if (file.type.startsWith("image")) {
            let compressedFile = await this.compressImage(file.file, {
              quality: 0.7,
              type: "image/jpeg",
            });

            formData.append("files", compressedFile);
          } else {
            formData.append("files", file.file);
          }
        }
      }

      if (this.fileRecordtamal.length > 0) {
        for (let index = 0; index < this.fileRecordtamal.length; index++) {
          const file = this.fileRecordtamal[index];
          if (file.type.startsWith("image")) {
            let compressedFile = await this.compressImage(file.file, {
              quality: 0.7,
              type: "image/jpeg",
            });

            formData.append("files", compressedFile);
          } else {
            formData.append("files", file.file);
          }
        }
      }

      //post form to your endpoint adding the content type headers
      axios
        .post(this.baseaddress + "/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.dialogsave = true;

          if (!this.prevmelli) this.prevmelli = this.melli;

          if (!this.prevmelli2) this.prevmelli2 = this.melli;

          this.clearpage();

          //remove entry from the array
          // this.fileRecords.splice(index, 1);
          console.log(response);
        });
    },
    savepayam() {
      //this.newid = await this.getidd();

      if (!this.$refs.vtxt.validate()) {
        return;
      }

      // console.log("idd", idd);
      this.dialogpayam = false;
      const dataToSend = {
        idd2: this.cuurentidd,
        pym: this.payam,
      };

      //post form to your endpoint adding the content type headers
      axios
        .post(this.baseaddress + "/updatepayamsam", dataToSend, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("auth"),
          },
        })
        .then((response) => {
          this.getlist();
          //remove entry from the array
          // this.fileRecords.splice(index, 1);
          console.log(response);
          this.disbtnsave = false;
        });
    },
    payamseenins() {
      //this.newid = await this.getidd();
      // console.log("idd", idd);
      // this.dialogpayam = false;
      const dataToSend = {
        idd2: this.cuurentidd,
        //  pym: this.payam,
      };

      //post form to your endpoint adding the content type headers
      axios
        .post(this.baseaddress + "/payamseenins", dataToSend, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // this.fileRecords.splice(index, 1);
          console.log(response);
        });
    },
    deleterequest(idd) {
      //this.newid = await this.getidd();
      // console.log("idd", idd);
      this.quesdelete = false;
      //this.user = "1";
      const dataToSend = {
        idd2: this.deleteidd,
        user: this.user,
      };

      //post form to your endpoint adding the content type headers
      axios
        .post(this.baseaddress + "/senddelsam", dataToSend, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.getlist();
          //remove entry from the array
          // this.fileRecords.splice(index, 1);
          console.log(response);
        });
    },
    setbayegani(idd, vas) {
      //this.newid = await this.getidd();
      // console.log("idd", idd);

      if (vas < 3) {
        this.showtoast("امکان تغییر وضعیت درخواست وجود ندارد");
      }

      this.quesdelete = false;
      // this.user = "1";
      const dataToSend = {
        idd2: idd,
        user: this.user,
      };

      //post form to your endpoint adding the content type headers
      axios
        .post(this.baseaddress + "/sendarchive", dataToSend, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.getlist();
          //remove entry from the array
          // this.fileRecords.splice(index, 1);
          console.log(response);
        });
    },

    payamseen(idd) {
      //this.newid = await this.getidd();
      // console.log("idd", idd);

      const dataToSend = {
        idd2: idd,
        user: this.user,
      };

      //post form to your endpoint adding the content type headers
      axios
        .post(this.baseaddress + "/payamseenins", dataToSend, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // this.getlist();
          //remove entry from the array
          // this.fileRecords.splice(index, 1);
          console.log(response);
        });
    },

    async handleFileChange(event) {
      return;
      const file = event.target.files[0];
      const dataTransfer = new DataTransfer();
      if (file) {
        // For every file in the files list

        // We compress the file by 50%
        const compressedFile = await this.compressImage(file, {
          quality: 0.5,
          type: "image/jpeg",
        });

        // Save back the compressed file instead of the original file
        dataTransfer.items.add(compressedFile);

        // Set value of the file input to our new files list
        event.target.files = dataTransfer.files;
      }
    },
    sendtoserv(base64) {
      let axiosConfig = {
        headers: {
          pass: "229101",
          Authorization: localStorage.getItem("auth"),
        },
      };

      axios
        .post(
          this.baseaddress + "/sendimg",
          {
            base: base64,
          },
          axiosConfig
        )
        .then((response) => {
          console.log(response);
          //response.data
        })
        .catch((err) => {
          console.log("no data" + err.response.status);
        });
    },

    myclick() {
      console.log(document.getElementById("test1"));
      var base64 = this.getBase64Image(document.getElementById("test1"));
      this.sendtoserv(base64);
      console.log(base64);
    },

    getBase64Image(img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      var dataURL = canvas.toDataURL("image/png");
      return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
    },

    onchnagetab() {
      if (this.tab != "درخواستهای قبلی") {
        console.log("focus", this.$refs);

        setTimeout(() => {
          this.$refs.mellic[0].focus();
        }, 1000);
      } else {
        this.getlist();
      }
    },

    mylogin(e) {
      this.showlogin = false;
      this.showing = true;
      this.username = e.name;
      this.date2 = e.date;
      this.user = e.user;
      this.prevmelli = e.melli !== null ? e.melli : "0";
      this.prevmelli2 = e.melli2 !== null ? e.melli2 : "0";
      //this.melli = e.melli;
      let f = e.date;
      if (e.date) {
        this.date =
          f.substring(0, 4) + "/" + f.substring(4, 6) + "/" + f.substring(6, 9);
      }

      history.pushState(null, null, location.href);
      window.onpopstate = function () {
        history.go(1);
      };
      this.socket = io("https://pz.ihiof.ir/", {
        path: "/apiio/socket.io",
        transports: ["websocket"],
        secure: true,
        auth: { token: "mobile", clientid: this.user },
      });

      this.socket.on("newreq", (data) => {
        console.log("play sound");
        this.playSound();
        this.getlist();
      });

      this.getlist();

      /*  this.socket.on("mass", (data) => {
        console.log("play sound");
        this.playSound();
      }); */

      setTimeout(() => {
        this.code = "";
      }, 800);

      if (e.chap == "1") {
        this.ischap = true;

        console.log(this.ischap);
      }
    },

    demostart(e) {
      console.log(e);
    },

    gotopage(index) {
      this.tab = this.name;
      //this.$emit("gotop",index)
      // bus.$emit("gotop",index)

      setTimeout(() => {
        this.$bus.$emit("gotop", index);
      }, 1000);
    },
    checkcode() {
      if (this.iscode == 1) {
        return " کد الزامی است ";
      }

      if (this.iscode == 2) {
        return " کد نامعتبر است  ";
      }

      return "";
    },

    searchsanad() {
      /* if (this.code == "") {
        this.iscode = 1;
        return;
      } */
      console.log("response");
      let axiosConfig = {
        headers: {
          pass: "229101",
          Authorization: localStorage.getItem("auth"),
        },
      };

      axios
        .post(
          this.baseaddress + "/getallimgsam22",
          {
            melli: this.melli,
            rah: this.rahh,
          },
          axiosConfig
        )
        .then((response) => {
          console.log(response.data);
          // this.progres = true;
          this.lastsanad = response.data;

          this.counter = response.data.length;
          this.result = response.data;

          setTimeout(() => {
            this.progres = false;
          }, 1000);

          this.listoffiles = this.lastsanad;

          //document.getElementById("lstitem40").scrollIntoView();

          //response.data
        })
        .catch((err) => {
          console.log("no data" + err);

          this.showtoast("سندی با مشخصات فوق پیدا نشد ");

          //if (err.response.status == 401) this.iscode = 2;
        });
    },

    showtoast(txt) {
      this.$toast(txt, {
        toastClassName: "my-custom-toast-class",
        position: "top-center",
        timeout: 3000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: false,
        closeButton: "button",
        icon: true,
        rtl: true,
      });
    },
    showtoast6(txt) {
      this.$toast(txt, {
        toastClassName: "my-custom-toast-class",
        position: "top-center",
        timeout: 6000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: false,
        closeButton: "button",
        icon: true,
        rtl: true,
      });
    },

    iconshow(e) {
      alert(e);
    },

    closetab(e) {
      return;
      var index = this.litems.indexOf(e);

      if (index >= 1) {
        if (e.code == this.code) this.result = [];

        this.litems.splice(index, 1);
      }
    },
    additem() {
      this.institle = this.lastsanad[0].TITLE;
      var tt = {
        idd: this.idd++,
        titl: this.lastsanad[0].TITLE,
        name: "کد" + this.code,
        code: this.code,
        it: this.lastsanad,
      };

      this.upsert(this.litems, tt);

      this.name = tt.name;

      if (this.fastview) {
        this.tab = tt.name;
      }

      //console.log(this.litems)
    },

    upsert(array, item) {
      // (1)
      const i = array.findIndex((_item) => _item.code === item.code);
      if (i > -1) array[i] = item; // (2)
      else array.push(item);
    },

    demoevent() {
      this.demo = true;
      // this.$tours['myTour'].nextStep()
    },

    eexit() {
      this.showlogin = true;

      //this.litems = [{ idd: 100, name: "درخواستها", code: 9 }];
      this.lastsanad = [];
      this.result = [];
      this.name = "";
      this.institle = "";

      this.showing = !this.showing;
    },

    getlist() {
      // this.date2 = "14020808";
      let axiosConfig = {
        headers: {
          oss: this.ostan,
          Authorization: "Bearer " + localStorage.getItem("auth"),
        },
      };

      axios
        .post(
          this.baseaddress + "/getlistsam",
          {
            user: this.user,
            pass: this.pass,
            os: this.ostan,
            ta: this.date2,
          },
          axiosConfig
        )
        .then((response) => {
          this.unfilterrows = response.data;
          if (!this.allsanad) {
            this.rows = this.unfilterrows.filter((item) => {
              return item.vas < 5;
            });
          } else {
            this.rows = response.data;
          }
          this.totalcon = this.rows.length;
          console.log(response.data);
          return 1;
        })
        .catch((err) => {
          console.log("ffff");
          /*
          if(err.toJSON().message === 'Network Error'){
        alert('no internet connection');

        } */

          if (!err.response) {
            this.showtoast("ارتباط خود با اینترنت را چک کنید");
            console.log("قطع است ");
          } else {
            console.log(err.response.status);

            this.showtoast("نام کاربری یا رمز شما صحیح نیست");
          }
        });
    },
    async getvasiat(idd) {
      // this.date2 = "14020808";
      let axiosConfig = {
        headers: {
          oss: this.ostan,
          Authorization: "Bearer " + localStorage.getItem("auth"),
        },
      };

      let response = await axios.post(
        this.baseaddress + "/getlistsam",
        {
          user: this.user,
          pass: this.pass,
          os: this.ostan,
          ta: this.date2,
        },
        axiosConfig
      );
      if (response) {
        this.unfilterrows = response.data;
        if (!this.allsanad) {
          this.rows = this.unfilterrows.filter((item) => {
            return item.vas < 5;
          });
        } else {
          this.rows = response.data;
        }

        let vas = this.rows.find((x) => x.idd === idd).vas;

        return vas;
        //console.log(response.data);
      } else return -1;
    },

    login() {
      let axiosConfig = {
        headers: {
          pass: "229101",
          Authorization: "Bearer " + localStorage.getItem("auth"),
        },
      };

      axios
        .post(
          this.baseaddress + "/jwt2",
          {
            user: this.user,
            pass: this.pass,
          },
          axiosConfig
        )
        .then((response) => {
          localStorage.setItem("auth", response.data.access_token);
          // console.log(response.data.access_token);
        })
        .catch((err) => {
          console.log(err.response.status);
        });
    },

    onBeforeDelete(fileRecord, i) {
      // optionally, you can confirm and call the deleteFileRecord method
      console.log("ss", this.$refs);
      if (i == 1) {
        this.$refs.imgFileAgent[0].deleteFileRecord(fileRecord);
      }
    },
    onBeforeDelete2(fileRecord, i) {
      // optionally, you can confirm and call the deleteFileRecord method
      console.log("ss", this.$refs);

      this.$refs.imgFileAgentaz[0].deleteFileRecord(fileRecord);
    },
    onBeforeDelete3(fileRecord, i) {
      // optionally, you can confirm and call the deleteFileRecord method
      console.log("ss", i);

      this.$refs.imgFileAgenttas[0].deleteFileRecord(fileRecord);
    },

    onBeforeDelete4(fileRecord, i) {
      // optionally, you can confirm and call the deleteFileRecord method
      console.log("ss", i);

      this.$refs.imgFileAgentama[0].deleteFileRecord(fileRecord);
    },

    getFileRecordsInitial: function () {
      return window.getFileRecordsInitial();
    },
    filesSelected: function (fileRecords) {
      /*   this.fileRecords.forEach((file, index) => {
        this.files.push(file.name());
      }); */

      console.log(this.files);
      //  console.log("ff", fileRecords[0].name());
      console.log(JSON.stringify(fileRecords));
      // manual handling
      // this.$refs.vueFileInput.upload(this.uploadUrl, fileRecords);
    },
    fileDeleted: function (fileRecord) {
      console.log("deleted");
      // manual handling
      // this.$refs.vueFileInput.deleteUpload(this.uploadUrl, fileRecord);
    },
  },
};
</script>

<style>
@font-face {
  font-family: "IRAN";
  src: local("IRAN"), url("~@/assets/fonts/IRAN.ttf") format("truetype");
}

.hero {
  background: url("~@/assets/backsam3.png") !important;
  background-size: cover !important;
  background-position: center center !important;
  background-repeat: no-repeat !important;
}
.farsi {
  font-family: "IRAN";
}

.v-application .title {
  font-family: "IRAN" !important;
}

.bkk {
  background-color: #439889 !important;
}

.prim {
  background-color: #455a64 !important;
  height: 50px !important;
}

.lff {
  display: block;
  margin: 0 auto;
}
.v-step__button,
.v-tour {
  font-family: "IRAN" !important;
}
.rotate-45 {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(180deg);
}

.v-application .primary--text {
  color: white !important;
}

.wtxt {
  color: white !important;
}

.tdv {
  height: 50px !important;
  width: 10px !important;
}

.v-application {
  font-family: "IRAN" !important;
}

* {
  color-adjust: exact !important;
}

.riztar {
  background-color: #edeef0;
}

.org {
  color: rgb(212, 124, 66) !important;
}
.container {
  padding-top: 1px !important;
}

.abc.v-alert:not(.v-sheet--tile) {
  border-bottom-right-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}

.v-alert__icon {
  margin-left: 2px !important;
}

.v-alert,
.v-alert__icon.v-icon {
  color: rgb(230, 236, 235);
  padding: 0 !important;
}

.theme--light.v-sheet--outlined {
  border: 0 !important;
}

.v-alert {
  margin-bottom: 0 !important;
}

.neomor {
  border-radius: 50px;
  background: #ffffff;
  box-shadow: inset 5px 5px 10px #b5b5b5, inset -5px -5px 10px #ffffff;
}

.tooltip {
  display: inline;
  position: relative;
}

.tooltip:hover {
  color: #c00;
  text-decoration: none;
}

.tooltip:hover:after {
  background: rgb(142, 145, 151);
  background: rgba(148, 143, 143, 0.8);
  border-radius: 0.5em;
  bottom: 1.35em;
  color: #fff;
  content: attr(title);
  display: block;
  left: 1em;
  padding: 0.3em 1em;
  position: absolute;
  text-shadow: 0 1px 0 #000;
  white-space: nowrap;
  z-index: 98;
}

.tooltip:hover:before {
  border: solid;
  border-color: #111 transparent;
  border-color: rgba(0, 0, 0, 0.8) transparent;
  border-width: 0.4em 0.4em 0 0.4em;
  bottom: 1em;
  content: "";
  display: block;
  left: 2em;
  position: absolute;
  z-index: 99;
}

.stik {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 4;
}

.farsi {
  font-family: "IRAN";
}

.mytable table {
  /* background-color: rgb(111, 145, 121 ,0.5); */
  border-bottom: none !important;
}

.v-data-table > .v-data-table__wrapper > table {
  background-color: #eaf0d5d1;
}
.theme--light.v-data-table tbody tr.v-data-table__selected {
  background: #bcc5c5 !important;
}
.theme--dark.v-data-table tbody tr.v-data-table__selected {
  background: #cfd8dc !important;
}
.theme--dark.v-data-table tbody tr.v-data-table__selected:hover {
  background: #a8b4b9 !important;
}
.theme--light.v-data-table tbody tr.v-data-table__selected:hover {
  background: #a8b4b9 !important;
}

tr.v-data-table__selected {
  background: #7d92f5 !important;
}

.v-input {
  font-size: 14px !important ;
}

/* .v-table tr:hover : (.v-table__expanded__content) {
  background: red !important;
}
 */
.mytable table {
  /* background-color: rgb(111, 145, 121 ,0.5); */
  border-bottom: none !important;
}

/* .v-data-footer {
  background-color: rgba(111, 145, 121, 0.5);
  border-bottom: none !important;
} */

.v-data-table-header,
.v-data-footer,
.v-data-table--fixed-header thead th {
  background-color: #607d8b !important;
  height: 43px !important;
}

.v-data-footer {
  color: white !important;
}

.mrr {
  margin-right: -300px !important;
}

.sec {
  padding-right: -5px !important;
}

.abc.v-alert:not(.v-sheet--tile) {
  border-bottom-right-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}

.v-alert__icon {
  margin-left: 2px !important;
}

.v-alert,
.v-alert__icon.v-icon {
  color: rgb(230, 236, 235);
  padding: 0 !important;
}

.theme--light.v-sheet--outlined {
  border: 0 !important;
}

.theme--light.v-chip {
  color: rgba(99, 95, 95, 0.87);
}

.btn__p100 {
  width: 100% !important;
}

.riztar {
  font-size: 12px;
}

.dorosht {
  font-size: 15px !important;
}

.v-application {
  font-family: "IRAN" !important;
}

.v-tooltip__content {
  background-color: #7d92f5 !important;
}

/* .v-dialog{
border: 2px solid rgb(83, 83, 95) !important;
} */
.v-data-footer__select {
  display: none !important;
}

@media print {
  .no-print {
    display: none !important;
  }
}

.v-application .title {
  font-family: "IRAN" !important;
}
.v-data-table-header tr {
  box-shadow: 0px 3px 3px -2px rgb(0 0 0 / 20%),
    0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%) !important;
}

.par {
  position: relative;
}

.cld {
  position: absolute;
  top: -6px;
  left: 30px;
}

.v-data-footer {
  height: 50px !important;
}

/* .v-alert:not(.v-sheet--tile) {

 border-bottom-left-radius: unset !important;
 border-bottom-right-radius: unset !important;

} */

.v-alert .v-alert__icon.v-icon {
  margin-top: -4px;
}

.printonly {
  display: none;
}

@media print {
  .printonly {
    display: block;
  }
}

.v-icon--right {
  margin-left: 0px !important;
}
.v-textarea {
  background-color: #e8eded;
}
body {
  -webkit-print-color-adjust: exact !important;
}
.v-alert__content {
  margin-right: 5px !important;
}
.savbtn {
  height: 50px !important;
}

.lstitem:hover {
  background-color: #c9cfcf;
}
.lstitem:active {
  background-color: #82c1df;
}

.row-pointer {
  cursor: pointer;
}
.v-data-footer__select {
  display: none !important;
}
.v-data-footer__pagination {
  display: block !important;
}
.dlgarea {
  width: 400px;
  height: 300px;
}
.mellicss {
  letter-spacing: 0.1em;
}
.vpd-icon-btn {
  background-color: #00838f !important;
}
.iddpointer {
  cursor: pointer;
}
.imgg {
  margin: 3px;
  width: 45px;
  height: 45px;
  border: #00838f 1px dotted;
  display: inline-block;
  vertical-align: middle;
}

.listfile {
  direction: ltr;
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}

.blink_me {
  color: #e6f5f2 !important;
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0.3;
  }
}

.panev {
  margin-bottom: 4px !important;
  font-size: 15px !important;
  display: flex;
}
.dwnlink {
  margin-right: 20px;
  color: #7ff1ec !important;
  vertical-align: middle;
}
.dwnlink a {
  color: #7ff1ec !important;
}
</style>
